type AnswerPart = { type: string; text?: string }

/**
 * What a user means by "copy the answer": the text of the answer, as plain
 * Markdown. Work steps, tool output and data parts are not part of it.
 */
export function answerText(message: { parts: readonly AnswerPart[] }): string {
  return message.parts
    .filter(part => part.type === 'text' && part.text)
    .map(part => part.text as string)
    .join('\n\n')
    .trim()
}
